require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-on-january-25-2019-the-director-of-iiscal-paulina.json") })
        }
      }, "path---en-us-update-on-january-25-2019-the-director-of-iiscal-paulina");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-on-january-25-2019-the-director-of-iiscal-paulina!./.cache/json/en-us-update-on-january-25-2019-the-director-of-iiscal-paulina.json
// module id = 781
// module chunks = 231608221292675